import type { MetaFunction } from '@remix-run/node'
import { accessAction } from '~/actions/access'
import { Footer, Header } from '~/design-system/components'
import AccessForm from '~/design-system/components/AccessForm'
import BreadCrumbsList, { usePreviousRoute } from '~/design-system/components/BreadCrumbList'
import { Card, HeaderCard } from '~/design-system/primitives'
import { HowToReg } from '~/icons'
import { cn } from '~/lib/cn'
import { accessLoader } from '~/loaders/access'

export const handle = {
  breadcrumb: 'Confirme sua identidade',
}

export const meta: MetaFunction = () => {
  return [
    {
      name: 'description',
      content:
        'Acesse sua conta Swift para continuar sua compra ou crie uma nova conta em poucos passos e aproveite nossos serviços exclusivos.',
    },
    { title: 'Login ou Cadastro - Swift' },
  ]
}

export const action = accessAction

export const loader = accessLoader

export default function Login() {
  const previousRoute = usePreviousRoute()

  return (
    <>
      <Header />
      <main className="flex flex-col items-center py-6 px-4 min-h-[500px] lg:min-h-[600px] bg-gray-10 justify-center">
        <div className={cn('lg:w-1/3 lg:min-1/3 h-fit self-center')}>
          <div className="flex flex-none align-center">
            <BreadCrumbsList prependCrumbs={[{ name: 'Voltar', href: previousRoute }]} />
          </div>
          <Card color="primary" border>
            <HeaderCard description="Confirme sua identidade" icon={<HowToReg />} />
            <AccessForm />
          </Card>
        </div>
      </main>
      <Footer />
    </>
  )
}
